import { render, staticRenderFns } from "./M_task.vue?vue&type=template&id=b8b77132&scoped=true&"
import script from "./M_task.vue?vue&type=script&lang=js&"
export * from "./M_task.vue?vue&type=script&lang=js&"
import style0 from "./M_task.vue?vue&type=style&index=0&id=b8b77132&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b77132",
  null
  
)

export default component.exports